var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTouCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{}\n\t.st1{fill:none;stroke-width:3.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:none;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7,18.7c3.2,0,5.7-2.6,5.7-5.7c0-3.2-2.6-5.7-5.7-5.7S1.2,9.9,1.2,13C1.3,16.2,3.8,18.7,7,18.7z M15.6,12.1 c1.8-0.9,3.1-2.9,3.1-5.1c0-3.2-2.6-5.7-5.7-5.7c-2.2,0-4.1,1.3-5.1,3.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouCoins);
export default __webpack_public_path__ + "static/media/touCoins.adf43e3613c2a2852c1b40fcb4cf855f.svg";
export { ForwardRef as ReactComponent };